import React, { Component } from 'react';
import { Container, Row, Col } from 'react-grid-system';

import classNames from 'classnames';
import { Badge } from 'components/badge';
import { Select } from 'components/input';
import SearchFilter from 'components/input/search/SearchFilter';
import { I18n } from 'components/translate';
import { inject, observer } from 'mobx-react';
import {
  DeepSearchService,
  DeepSearchStore as Store
} from 'modules/userManager';
import DeepSearch from 'modules/userManager/userSearch/deepSearch/DeepSearch';
import PropTypes from 'prop-types';

import './Search.scss';

@inject((stores) => ({
  simpleFilterParams: stores.DeepSearchStore.simpleFilterParams,
  deepSearchOpened: stores.DeepSearchStore.deepSearchOpened,
  error: stores.DeepSearchStore.error,
  isDeepSearch: stores.DeepSearchStore.isDeepSearch,
  loadingSearch: stores.DeepSearchStore.loadingSearch,
  page: stores.UserManagerStore.page
}))
@observer
export default class Search extends Component {
  static propTypes = {
    getUsers: PropTypes.func,
    simpleFilterParams: PropTypes.object,
    deepSearchOpened: PropTypes.bool,
    error: PropTypes.bool,
    isDeepSearch: PropTypes.bool,
    loadingSearch: PropTypes.bool,
    page: PropTypes.number
  };

  searchUsers = () => DeepSearchService.searchUsers();

  enableErrorFields = () => DeepSearchService.enableErrorFields();

  disableErrorFields = () => DeepSearchService.disableErrorFields();

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.toggleDeepSearch = this.toggleDeepSearch.bind(this);
  }

  toggleDeepSearch = () => {
    this.props.deepSearchOpened
      ? DeepSearchService.closeDeepSearch()
      : DeepSearchService.openDeepSearch();
  };

  handleChange(value) {
    const { simpleFilterParams } = this.props;

    simpleFilterParams.query = value;
    DeepSearchService.setSearchType(false);

    DeepSearchService.searchUsers();
  }

  get classCollapse() {
    const classCollapsed = 'users__manager__deep__search--collapse';
    const classOpened = 'users__manager__deep__search';
    const { deepSearchOpened } = this.props;

    return deepSearchOpened ? classOpened : classCollapsed;
  }

  get placeholder() {
    const { isDeepSearch, deepSearchOpened } = this.props;
    const shouldRenderBadge = isDeepSearch || deepSearchOpened;

    return (
      <div className="deep__search__placeholder">
        <I18n html label="users_manager.users_list.filter.search" />
        {shouldRenderBadge && (
          <Badge value={Store.deepSearch.totalFilterCount} />
        )}
      </div>
    );
  }

  render() {
    const { deepSearchOpened, error, loadingSearch, simpleFilterParams } =
      this.props;
    const searchClass = 'users__manager__search__filter__icon';
    const loadingClass = 'users__manager__search__filter__icon--loading';
    const classIcon = classNames(searchClass, {
      [loadingClass]: loadingSearch
    });

    return (
      <Container fluid className="users__form p__0">
        <Row nogutter className="row__users">
          <Col xs={12} md={3} className="users__manager__search__select">
            <Select
              name="class"
              className="class__select users__manager__select__filter"
              components={{
                Placeholder: () => this.placeholder
              }}
              onToogleOpen={this.toggleDeepSearch}
              isClearable={false}
              isSearchable={false}
              menuIsOpen={false}
              closeClickingOutside={false}
              totalFilterCount={Store.deepSearch.totalFilterCount}
            />
          </Col>
          <Col xs={12} md={9}>
            <SearchFilter>
              <SearchFilter.SearchInput
                autoComplete="off"
                icon={loadingSearch ? 'processing' : 'search'}
                maxLength="120"
                className="users__manager__search__filter"
                position="right"
                placeholder="users_manager.users_list.filter.input"
                classIcon={classIcon}
                disabled={deepSearchOpened}
                onChange={this.handleChange}
                value={simpleFilterParams.query}
              />
            </SearchFilter>
          </Col>
        </Row>

        <DeepSearch
          className={this.classCollapse}
          searchUsers={this.searchUsers}
          error={error}
          enableErrorFields={this.enableErrorFields}
          disableErrorFields={this.disableErrorFields}
        />
      </Container>
    );
  }
}
